import React from 'react';
import SEO from '../../../Components/SEO';
import Breadcrumb from '../../../Components/Breadcrumb';
import { ActivityLayout } from '../../../Components/activity-layout';

const TeachEnglishPageLayout = ({
  title,
  eyebrow = 'Teaching Guide',
  image,
  intro,
  seoContent = [],
  levels = [],
  seoTitle,
  seoDescription,
  children,
}) => {
  return (
    <ActivityLayout
      title={title}
      eyebrow={eyebrow}
      image={image}
      intro={intro}
      seoContent={seoContent}
      levels={levels}
    >
      <SEO
        title={seoTitle || title}
        description={seoDescription || intro}
        type="article"
        image={image}
      />
      <Breadcrumb />
      {children}
    </ActivityLayout>
  );
};

export default TeachEnglishPageLayout;